import ApplicationAdapter from '../application';

export default class Base extends ApplicationAdapter {
  namespace = 'auth/v4';

  pathForType() {
    return super
      .pathForType(...arguments)
      .replace('auth/', '')
      .toLowerCase();
  }
}
